<div class="manage-substation-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="manage-substation-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="manage-substation-shell__sidebar"
    [class.manage-substation-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-substation-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-substation-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-substation-page">
      <section class="manage-substation-page__heading">
        <div class="manage-substation-page__heading-copy">
          <h2 class="app-title-serif">Manage Substation</h2>
        </div>

        <button type="button" class="app-button app-button--primary manage-substation-page__add-button" (click)="openAddSubstationModal()">
          <span class="manage-substation-page__add-icon">+</span>
          <span>Add New Substation</span>
        </button>
      </section>

      <section class="manage-substation-page__filters app-card">
        <form class="manage-substation-filters" [formGroup]="filterForm">
          <label class="app-form-field manage-substation-filters__field">
            <span class="app-form-label">Search</span>
            <div class="manage-substation-filters__search">
              <span class="manage-substation-filters__search-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <path d="m20 20-3.5-3.5"></path>
                </svg>
              </span>
              <input id="manage-substation-search" class="app-form-input manage-substation-filters__search-input" type="text" placeholder="Search" formControlName="search" />
            </div>
          </label>

          <div class="app-form-field manage-substation-filters__field">
            <label class="app-form-label" [attr.for]="provinceFilterInputId">Province</label>
            <p-autocomplete
              [inputId]="provinceFilterInputId"
              [(ngModel)]="provinceSearchTerm"
              [ngModelOptions]="{ standalone: true }"
              [dropdown]="true"
              size="compact"
              optionLabel="name"
              [suggestions]="filteredProvinceOptions"
              placeholder="Select Province"
              (completeMethod)="onProvinceSearchInput($event)"
              (fieldBlur)="onProvinceSearchBlur()"
            ></p-autocomplete>
          </div>

          <div class="app-form-field manage-substation-filters__field">
            <label class="app-form-label" [attr.for]="districtFilterInputId">District</label>
            <p-autocomplete
              [inputId]="districtFilterInputId"
              [(ngModel)]="districtSearchTerm"
              [ngModelOptions]="{ standalone: true }"
              [dropdown]="true"
              size="compact"
              optionLabel="name"
              [suggestions]="filteredDistrictFilterOptions"
              placeholder="Select District"
              (completeMethod)="onDistrictSearchInput($event)"
              (fieldBlur)="onDistrictSearchBlur()"
            ></p-autocomplete>
          </div>

          <label class="app-form-field manage-substation-filters__field">
            <span class="app-form-label">Grid Division</span>
            <select class="app-form-select" formControlName="grid_division">
              <option value="all">All Grid Divisions</option>
              @for (gridDivision of gridDivisionOptions; track gridDivision) {
                <option [value]="gridDivision">{{ gridDivision }}</option>
              }
            </select>
          </label>

          <div class="manage-substation-filters__clear">
            <button
              type="button"
              class="app-button app-button--secondary equal app-filter-actions__button"
              [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
              (click)="clearFilters()"
            >
              Clear
            </button>
          </div>

          <div class="manage-substation-filters__actions">
            <button
              type="button"
              class="app-button app-button--secondary manage-substation-filters__menu-button app-action-menu-trigger"
              [class.manage-substation-filters__menu-button--open]="isSubstationActionMenuOpen"
              [class.app-action-menu-trigger--open]="isSubstationActionMenuOpen"
              [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
              (click)="toggleSubstationActionMenu()"
              aria-label="Open substation actions"
            >
              <svg class="manage-substation-filters__menu-icon app-action-menu-trigger__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <circle cx="12" cy="5.5" r="1.5"></circle>
                <circle cx="12" cy="12" r="1.5"></circle>
                <circle cx="12" cy="18.5" r="1.5"></circle>
              </svg>
            </button>

            @if (isSubstationActionMenuOpen) {
              <div class="manage-substation-filters__menu app-action-menu-panel">
                <button
                  type="button"
                  class="app-button app-button--secondary manage-substation-filters__menu-item app-action-menu-item"
                  title="Export Data"
                  aria-label="Export Data"
                  [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                  (click)="handleExportSubstations()"
                >
                  <span class="app-action-menu-item__icon" aria-hidden="true">
                    <i class="fa-solid fa-file-export" aria-hidden="true"></i>
                  </span>
                </button>

                <button
                  type="button"
                  class="app-button app-button--secondary manage-substation-filters__menu-item app-action-menu-item"
                  title="Download Template"
                  aria-label="Download Template"
                  [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                  (click)="handleDownloadTemplate()"
                >
                  <span class="app-action-menu-item__icon" aria-hidden="true">
                    <i class="fa-solid fa-download" aria-hidden="true"></i>
                  </span>
                </button>

                <button
                  type="button"
                  class="app-button app-button--primary manage-substation-filters__menu-item app-action-menu-item"
                  title="Import Data"
                  aria-label="Import Data"
                  [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                  (click)="triggerSubstationImportFilePicker(substationImportInput)"
                >
                  <span class="app-action-menu-item__icon" aria-hidden="true">
                    <i class="fa-solid fa-file-import" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
            }

            <input
              #substationImportInput
              type="file"
              class="manage-substation-filters__import-input"
              accept=".xlsx"
              (change)="onSubstationImportFileSelected($event)"
            />
          </div>
        </form>
      </section>

      <section class="manage-substation-page__table app-card">
        <div class="manage-substation-page__table-wrap app-table-scroll">
          <table class="manage-substation-table">
            <thead>
              <tr>
                <th>S.No.</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('station_name')" [attr.aria-label]="'Sort by Station Name'"><span>Station Name</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('station_name')" [class.manage-sort-icon--descending]="isSortDescending('station_name')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('code')" [attr.aria-label]="'Sort by SCADA Code'"><span>SCADA Code</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('code')" [class.manage-sort-icon--descending]="isSortDescending('code')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('province')" [attr.aria-label]="'Sort by Province'"><span>Province</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('province')" [class.manage-sort-icon--descending]="isSortDescending('province')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('district')" [attr.aria-label]="'Sort by District'"><span>District</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('district')" [class.manage-sort-icon--descending]="isSortDescending('district')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                <th>Grid Division</th>
                <th>Generators</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Capacity(MVA)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="11" class="manage-substation-page__empty-state">Loading substations...</td>
                </tr>
              } @else if (filteredSubstations.length) {
                @for (item of filteredSubstations; track trackBySubstationId($index, item)) {
                  <tr>
                    <td>{{ item.serial_no }}</td>
                    <td>{{ item.station_name }}</td>
                    <td>{{ item.scada_code || '-' }}</td>
                    <td>{{ item.state_name ?? getStateName(item.state_id) }}</td>
                    <td>{{ item.district_name ?? getDistrictName(item.district_id) }}</td>
                    <td>{{ item.grid_division || '-' }}</td>
                    <td>
                      <button
                        type="button"
                        class="app-button app-button--secondary manage-substation-page__generator-count-button"
                        [disabled]="isLoading"
                        (click)="openSubstationGeneratorsModal(item)"
                      >
                        {{ item.generator_count }}
                      </button>
                    </td>
                    <td>{{ item.lat || '-' }}</td>
                    <td>{{ item.long || '-' }}</td>
                    <td>{{ item.capacity ?? '-' }}</td>
                    <td>
                      <div class="manage-substation-page__actions">
                        <div class="app-row-action-menu">
                          <details class="app-row-action-menu__details">
                            <summary class="app-row-action-menu__toggle" aria-label="Open substation actions">
                              <span class="app-row-action-menu__dots" aria-hidden="true">
                                <span></span>
                                <span></span>
                                <span></span>
                              </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewSubstationModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                    <circle cx="12" cy="12" r="2.8"></circle>
                                  </svg>
                                </span>
                                <span>View</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditSubstationModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                    <path d="m13.5 6.5 4 4"></path>
                                  </svg>
                                </span>
                                <span>Edit</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteSubstationModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 6h18"></path>
                                    <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                    <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                    <path d="M10 10v6"></path>
                                    <path d="M14 10v6"></path>
                                  </svg>
                                </span>
                                <span>Delete</span>
                              </button>
                            </div>
                          </details>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              } @else {
                <tr>
                  <td colspan="11" class="manage-substation-page__empty-state">No substations found</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (canShowPagination()) {
          <div class="manage-substation-page__pagination">
            <div class="manage-substation-page__pagination-summary">
              <span>{{ getPaginationLabel() }}</span>
            </div>

            <div class="manage-substation-page__pagination-actions">
              <button type="button" class="app-button app-button--secondary manage-substation-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                Previous
              </button>

              <div class="manage-substation-page__pagination-pages" aria-label="Pagination pages">
                @for (page of getPaginationItems(); track $index) {
                  @if (page === -1) {
                    <span class="manage-substation-page__pagination-ellipsis" aria-hidden="true">...</span>
                  } @else {
                    <button type="button" class="manage-substation-page__pagination-page" [class.manage-substation-page__pagination-page--active]="pagination.page_no === page" [disabled]="isLoading" (click)="goToPage(page)">{{ page }}</button>
                  }
                }
              </div>

              <button type="button" class="app-button app-button--secondary manage-substation-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                Next
              </button>
            </div>

            <label class="manage-substation-page__pagination-size">
              <span class="manage-substation-page__pagination-size-label">Rows per page</span>
              <select class="app-form-select manage-substation-page__pagination-select" [formControl]="pageSizeControl">
                @for (size of pageSizeOptions; track size) {
                  <option [ngValue]="size">{{ size }}/Page</option>
                }
              </select>
            </label>
          </div>
        }
      </section>
    </main>
  </div>

  @if (substationModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-substation-modal" open>
        <div class="manage-substation-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'edit' ? 'Edit Substation' : modalMode === 'view' ? 'View Substation' : 'Add New Substation' }}</h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-substation-modal__close" aria-label="Close modal" (click)="closeSubstationModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="substationForm" (ngSubmit)="saveSubstation()">
          <div class="manage-substation-modal__body">
            <div class="manage-substation-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">Station Name <span class="manage-substation-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="Station name" formControlName="station_name" (blur)="trimStationName()" />
                @if (isRequiredFieldInvalid('station_name')) {
                  <section class="app-form-error">Station name is required</section>
                }
              </label>

              @if (modalMode !== 'edit') {
                <label class="app-form-field">
                  <span class="app-form-label">Station Code <span class="manage-substation-modal__required">*</span></span>
                  <input class="app-form-input" type="text" placeholder="Station code" formControlName="station_code" maxlength="25" />
                  @if (isRequiredFieldInvalid('station_code')) {
                    <section class="app-form-error">Station code is required</section>
                  }
                </label>
              }

              <label class="app-form-field">
                <span class="app-form-label">SCADA Code</span>
                <input class="app-form-input" type="text" placeholder="SCADA code" formControlName="scada_code" maxlength="50" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Province</span>
                <select class="app-form-select" formControlName="state_id">
                  <option [ngValue]="null">Select Province</option>
                  @for (state of states; track state.id) {
                    <option [ngValue]="state.id">{{ state.name }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">District</span>
                <select class="app-form-select" formControlName="district_id" [disabled]="isDistrictSelectionDisabled">
                  <option [ngValue]="null">Select District</option>
                  @for (district of districts; track district.id) {
                    <option [ngValue]="district.id">{{ district.name }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Voltage Level</span>
                <select class="app-form-select" formControlName="voltage_level_id">
                  <option [ngValue]="null">Select Voltage Level</option>
                  @for (vl of voltageLevels; track vl.id) {
                    <option [ngValue]="vl.id">{{ vl.name }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Operational Status</span>
                <input class="app-form-input" type="text" placeholder="Operational status" formControlName="operational_status" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Capacity(MVA)</span>
                <input class="app-form-input" type="number" step="0.01" placeholder="Capacity(MVA)" formControlName="capacity" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">No of Capacitors</span>
                <input class="app-form-input" type="number" step="1" min="0" placeholder="No of Capacitors" formControlName="total_capacitors" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">No of Reactors</span>
                <input class="app-form-input" type="number" step="1" min="0" placeholder="No of Reactors" formControlName="total_reactors" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">No of Transformers</span>
                <input class="app-form-input" type="number" step="1" min="0" placeholder="No of Transformers" formControlName="total_transformers" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Grid Division</span>
                <select class="app-form-select" formControlName="grid_division">
                  <option value="">Select Grid Division</option>
                  @for (option of gridDivisionOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Logsheet</span>
                <select class="app-form-select" formControlName="logsheet">
                  @for (option of logsheetOptions; track option.label) {
                    <option [ngValue]="option.value">{{ option.label }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Latitude</span>
                <input class="app-form-input" type="number" step="any" min="-90" max="90" placeholder="Latitude" formControlName="lat" />
                @if (substationForm.get('lat')?.hasError('coordinateRange') && (substationForm.get('lat')?.touched || formSubmitted)) {
                  <section class="app-form-error">Latitude must be between -90 and 90.</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Longitude</span>
                <input class="app-form-input" type="number" step="any" min="-180" max="180" placeholder="Longitude" formControlName="long" />
                @if (substationForm.get('long')?.hasError('coordinateRange') && (substationForm.get('long')?.touched || formSubmitted)) {
                  <section class="app-form-error">Longitude must be between -180 and 180.</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Connectivity</span>
                <input class="app-form-input" type="text" placeholder="Connectivity" formControlName="connectivity" />
              </label>
            </div>
          </div>

          <div class="manage-substation-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeSubstationModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedSubstation) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-substation-delete">
        <div class="manage-substation-delete__header">
          <div class="manage-substation-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete Substation</h3>
            <p>This action will remove the substation</p>
          </div>
        </div>

        <p class="manage-substation-delete__copy">
          Are you sure you want to delete <strong>{{ selectedSubstation.station_name }}</strong>?
        </p>

        <div class="manage-substation-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }

  <ng-template #generatorTable let-items="items" let-loading="loading" let-loadingMessage="loadingMessage" let-emptyMessage="emptyMessage" let-actionMode="actionMode">
        <div class="manage-substation-generators-modal__body">
          @if (loading) {
            <div class="manage-substation-generators-modal__empty">{{ loadingMessage }}</div>
          } @else if (items.length) {
        <div class="manage-substation-generators-modal__table-wrap app-table-scroll">
          <table class="manage-substation-generators-modal__table" [class.manage-substation-generators-modal__table--action-first]="actionMode === 'assign'">
            <thead>
              <tr>
                @if (actionMode === 'assign') {
                  <th>Action</th>
                }
                <th>S.No.</th>
                <th>Generator Name</th>
                <th>Generator Code</th>
                <th>Generator Type</th>
                <th>Voltage Level</th>
                <th>Connecting Voltage Level</th>
                @if (actionMode !== 'assign') {
                  <th>Action</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (generator of items; track trackByGeneratorId($index, generator)) {
                <tr>
                  @if (actionMode === 'assign') {
                    <td>
                      <div class="manage-substation-generators-modal__checkbox">
                        <input
                          type="checkbox"
                          [checked]="isAvailableGeneratorSelected(generator.id)"
                          [disabled]="isGeneratorMappingSaving"
                          (change)="toggleAvailableGeneratorSelection(generator.id, $any($event.target).checked)"
                        />
                      </div>
                    </td>
                  }
                  <td>{{ generator.serial_no }}</td>
                  <td>
                    <span class="manage-substation-generators-modal__cell-ellipsis" [title]="generator.generator_name">{{ generator.generator_name }}</span>
                  </td>
                  <td>
                    <span class="manage-substation-generators-modal__cell-ellipsis" [title]="generator.generator_code || '-'">
                      {{ generator.generator_code || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="manage-substation-generators-modal__cell-ellipsis" [title]="generator.generator_type || '-'">
                      {{ generator.generator_type || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="manage-substation-generators-modal__cell-ellipsis" [title]="generator.voltage_level_label || '-'">
                      {{ generator.voltage_level_label || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="manage-substation-generators-modal__cell-ellipsis" [title]="generator.connecting_voltage_level_label || '-'">
                      {{ generator.connecting_voltage_level_label || '-' }}
                    </span>
                  </td>
                  @if (actionMode !== 'assign') {
                    <td>
                      <button
                        type="button"
                        class="app-button app-button--icon manage-substation-generators-modal__action manage-substation-generators-modal__action--remove"
                        aria-label="Remove generator"
                        [disabled]="isGeneratorMappingSaving"
                        (click)="unmapGeneratorFromSelectedSubstation(generator)"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="manage-substation-generators-modal__empty">{{ emptyMessage }}</div>
      }
    </div>
  </ng-template>

  @if (substationGeneratorsModalOpen && selectedSubstationForGenerators) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-substation-generators-modal" open>
        <div class="manage-substation-generators-modal__header">
          <div class="manage-substation-generators-modal__header-copy">
            <h3 class="app-title-serif">Generators</h3>
            <p>{{ selectedSubstationForGenerators.station_name }} · {{ selectedSubstationForGenerators.generator_count }} mapped generators</p>
          </div>

          <button type="button" class="app-button app-button--primary" (click)="openAddNewGeneratorModal()">Assign New Generator</button>

          <button type="button" class="manage-substation-generators-modal__close" aria-label="Close generators modal" (click)="closeSubstationGeneratorsModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M6 6l12 12"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <div class="manage-substation-generators-modal__body">
          <ng-container
            [ngTemplateOutlet]="generatorTable"
            [ngTemplateOutletContext]="{
              items: substationGenerators,
              loading: isSubstationGeneratorsLoading,
              loadingMessage: 'Loading mapped generators...',
              emptyMessage: 'No generators mapped to this substation.',
              actionMode: 'remove'
            }"
          ></ng-container>
        </div>

        <div class="manage-substation-generators-modal__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeSubstationGeneratorsModal()">Close</button>
        </div>
      </dialog>
    </div>
  }

  @if (substationGeneratorPickerModalOpen && selectedSubstationForGenerators) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-substation-generator-picker-modal" open>
        <div class="manage-substation-generators-modal__header">
          <div class="manage-substation-generators-modal__header-copy">
            <h3 class="app-title-serif">Assign New Generator</h3>
            <p>{{ selectedSubstationForGenerators.station_name }} · Select generators to map</p>
          </div>

          <button type="button" class="manage-substation-generators-modal__close" aria-label="Close add generator modal" (click)="closeGeneratorPickerModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M6 6l12 12"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <div class="manage-substation-generators-modal__body">
          <ng-container
            [ngTemplateOutlet]="generatorTable"
            [ngTemplateOutletContext]="{
              items: availableGenerators,
              loading: isAvailableGeneratorsLoading,
              loadingMessage: 'Loading available generators...',
              emptyMessage: 'No additional generators available for this substation.',
              actionMode: 'assign'
            }"
          ></ng-container>
        </div>

        <div class="manage-substation-generators-modal__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeGeneratorPickerModal()">Cancel</button>
          <button
            type="button"
            class="app-button app-button--primary"
            [disabled]="!selectedAvailableGeneratorIds.size || isGeneratorMappingSaving || isAvailableGeneratorsLoading"
            (click)="saveSelectedGenerators()"
          >
            Save
          </button>
        </div>
      </dialog>
    </div>
  }
</div>
